import * as React from 'react';

import { classNames } from '@core/utils/functions/class-names';
import Breadcrumb from '@/components/display/headers/Breadcrumb';

type PriceBreadcrumbProps = {
    title: string;
    code: string;
    className?: string;
};

const PriceBreadcrumb = (props: PriceBreadcrumbProps) => {
    const { title, code, className } = props;

    return (
        <div className={classNames('flex justify-start items-center relative gap-2', className)}>
            <Breadcrumb
                items={[
                    { title: 'prices', link: '/prices' },
                    { title, link: `/price/${code.toLowerCase()}` },
                ]}
            />
        </div>
    );
};

export default PriceBreadcrumb;
